import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { DadosIntegracaoVendaFiltroRequest } from '../../requests/scanntech/dados-integracao-venda-filtro.request';
import { DadosIntegracaoFechamentoFiltroRequest } from '../../requests/scanntech/dados-integracao-fechamento-filtro.request';
import { MarcarReprocessamentoVendasRequest } from '../../requests/scanntech/marcar-reprocessamento-vendas.request';
import { MarcarReprocessamentoFechamentosRequest } from '../../requests/scanntech/marcar-reprocessamento-fechamentos.request';
import { DadosIntegracaoVendaListaResponse } from '../../responses/scanntech/dados-integracao-venda-lista.response';
import { DadosIntegracaoFechamentoListaResponse } from '../../responses/scanntech/dados-integracao-fechamento-lista.response';
import { ListaLogVendaIntegracaoResponse } from '../../responses/scanntech/lista-log-venda-integracao.response';
import { ListaLogFechamentoIntegracaoResponse } from '../../responses/scanntech/lista-log-fechamento-integracao.response';

@Injectable({
  providedIn: 'root',
})
export class DadosIntegracaoScanntechService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listarVendas(
    filtro: DadosIntegracaoVendaFiltroRequest
  ): Observable<DadosIntegracaoVendaListaResponse> {
    return this.httpClient
      .post<DadosIntegracaoVendaListaResponse>(
        environment.urlApiScanntech + 'DadosIntegracao/vendas',
        filtro,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public listarFechamentos(
    filtro: DadosIntegracaoFechamentoFiltroRequest
  ): Observable<DadosIntegracaoFechamentoListaResponse> {
    return this.httpClient
      .post<DadosIntegracaoFechamentoListaResponse>(
        environment.urlApiScanntech + 'DadosIntegracao/fechamentos',
        filtro,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public listarLogsVenda(idVendaLote: number): Observable<ListaLogVendaIntegracaoResponse> {
    return this.httpClient
      .get<ListaLogVendaIntegracaoResponse>(
        environment.urlApiScanntech + `DadosIntegracao/vendas/${idVendaLote}/logs`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public listarLogsFechamento(idSomatorioFechamentoDiario: number): Observable<ListaLogFechamentoIntegracaoResponse> {
    return this.httpClient
      .get<ListaLogFechamentoIntegracaoResponse>(
        environment.urlApiScanntech +
          `DadosIntegracao/fechamentos/${idSomatorioFechamentoDiario}/logs`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public marcarVendasParaReprocessamento(
    request: MarcarReprocessamentoVendasRequest
  ): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiScanntech + 'DadosIntegracao/vendas/marcar-reprocessamento',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public desmarcarVendasParaReprocessamento(
    request: MarcarReprocessamentoVendasRequest
  ): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiScanntech + 'DadosIntegracao/vendas/desmarcar-reprocessamento',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public marcarFechamentosParaReprocessamento(
    request: MarcarReprocessamentoFechamentosRequest
  ): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiScanntech + 'DadosIntegracao/fechamentos/marcar-reprocessamento',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public desmarcarFechamentosParaReprocessamento(
    request: MarcarReprocessamentoFechamentosRequest
  ): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiScanntech + 'DadosIntegracao/fechamentos/desmarcar-reprocessamento',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
